import { motion } from "framer-motion";
import { kickerRow, kickerRule, kicker } from "../../styles/theme";

export default function SectionTag({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -10 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      style={kickerRow}
    >
      <span style={kickerRule} />
      <span style={kicker}>{children}</span>
    </motion.div>
  );
}
